import { useState } from 'react'
import { Link, useLocation } from 'react-router'
import { bridgeToLumen, mapLegacyOrgPathToLumen } from '@/lib/lumenHost'
import { ROUTES } from '@/constants/routes'
import { useUIStore } from '@/stores/ui'

/**
 * Legacy React `/org/*` — chooser only (no auto-nav to Lumen).
 */
export default function OrgConsoleRedirect() {
  const location = useLocation()
  const mapped = mapLegacyOrgPathToLumen(location.pathname) ?? '/lumen'
  const showToast = useUIStore((s) => s.showToast)
  const [opening, setOpening] = useState(false)

  async function openLumen() {
    if (opening) return
    setOpening(true)
    const result = await bridgeToLumen(mapped)
    if (!result.ok) {
      showToast(
        result.reason === 'no_user'
          ? 'Sign in to the family app first, then open Lumen.'
          : 'Could not open Lumen. Stay in the family app and try again.',
        'error',
      )
      setOpening(false)
    }
  }

  return (
    <div className="grid min-h-[60vh] place-items-center px-6 text-center">
      <div className="flex max-w-md flex-col items-center gap-4">
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-beacon-100 text-beacon-700">
          <i className="fa-solid fa-building-user text-2xl" aria-hidden="true" />
        </span>
        <div className="space-y-1">
          <h1 className="text-lg font-bold text-slate-900">Organization console moved</h1>
          <p className="text-sm text-slate-500 leading-relaxed">
            Staff tools live in <strong className="font-semibold text-slate-700">Lumen</strong>.
            We sign you in with your current family-app account when possible.
          </p>
        </div>
        <div className="flex w-full flex-col gap-2 sm:flex-row sm:justify-center">
          <button
            type="button"
            disabled={opening}
            onClick={() => { void openLumen() }}
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-beacon-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-beacon-700 disabled:opacity-70"
          >
            {opening ? 'Opening…' : 'Open Lumen'}
            {!opening && (
              <i className="fa-solid fa-arrow-up-right-from-square text-xs opacity-90" aria-hidden="true" />
            )}
          </button>
          <Link
            to={ROUTES.HOME}
            className="inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50"
          >
            Stay in family app
          </Link>
        </div>
      </div>
    </div>
  )
}
